enum Gender {
  'MALE' = 'MALE',
  'FEMALE' = 'FEMALE',
}

export { Gender }
